import { Card, Typography } from "antd";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import icon from "../../Assets/icon2.png";
import { PhoneOutlined } from "@ant-design/icons";

import {
  Arrow,
  ChangeLanguage,
  DeleteAccount,
  History,
  LinkAccounts,
  ReportIssue,
  ResetPin,
  TAndC,
  PAndP,
  UserProfile,
} from "../../Assets/icons";
import { Routes } from "../../Utils/Constants/routes";
import "./index.css";

const MoreScreen: React.FC = () => {
  const [language, setLanguage] = useState(
    localStorage.getItem("i18nextLng") || "en"
  );
  const { t, i18n } = useTranslation();
  const { push } = useHistory();

  const MoreCardDetails = [
    {
      key: "T&C",
      title: t("lblTermsAndConditions"),
      description: t("moreTermsDescription"),
      logoUrl: <TAndC className="moreItemIcons" />,
    },
    {
      key: "UserProfile",
      title: t("lblUserProfile"),
      description: t("moreProfileDescription"),
      logoUrl: <UserProfile className="moreItemIcons" />,
    },
    {
      key: "LinkAccount",
      title: t("lblLinkAccounts"),
      description: t("moreLinkAccountsDescription"),
      logoUrl: <LinkAccounts className="moreItemIcons" />,
    },
    {
      key: "ResetPin",
      title: t("lblResetPin"),
      description: t("moreResetPinDescription"),
      logoUrl: <ResetPin className="moreItemIcons" />,
    },
    // {
    //   key: "MobileNumbers",
    //   title: t("lblMobileNumbers"),
    //   description: t("lblMobileNumbersDescription"),
    //   logoUrl: <PhoneOutlined className="moreItemIcons" />,
    // },
    {
      key: "History",
      title: t("lblHistory"),
      description: t("moreHistoryDescription"),
      logoUrl: <History className="moreItemIcons" />,
    },
    {
      key: "ChangeLanguage",
      title:
        t("lblChangeLanguage") +
        ` - (${
          language === "en"
            ? t("lblHindi")
            : language === "hi"
            ? t("lblMarathi")
            : t("lblEnglish")
        })`,
      description: t("moreLanguageDescription"),
      logoUrl: <ChangeLanguage className="moreItemIcons" />,
    },
    {
      key: "GrievanceRedressal",
      title: t("lblGrievanceRedressal"),
      description: t("moreGrievanceDescription"),
      logoUrl: <PAndP className="moreItemIcons" />,
    },
    {
      key: "ReportIssue",
      title: t("lblReportIssue"),
      description: t("moreReportDescription"),
      logoUrl: <ReportIssue className="moreItemIcons" />,
    },
    {
      key: "DeleteAccount",
      title: t("lblDeleteAccount"),
      description: t("moreDeleteDescription"),
      logoUrl: <DeleteAccount className="moreItemIcons" />,
    },
    {
      key: "P&P",
      title: t("lblPrivacyAndPolicy"),
      description: t("morePrivacyDescription"),
      logoUrl: <PAndP className="moreItemIcons" />,
    },
  ];

  const cardOnClick = (key: string) => {
    switch (key) {
      case "T&C":
        push(Routes.more + Routes.termsandconditions);
        break;

      case "P&P":
        push(Routes.more + Routes.privacyandpolicy);
        break;

      case "GrievanceRedressal":
        push(Routes.more + Routes.grievanceredressal);
        break;

      case "UserProfile":
        push(Routes.more + Routes.userprofile);
        break;

      case "ResetPin":
        push(Routes.more + Routes.changePassword);
        break;

      case "MobileNumbers":
        push(Routes.more + Routes.mobileNumbers);
        break;

      case "LinkAccount":
        push(Routes.linkAccounts);
        break;

      case "DeleteAccount":
        push(Routes.more + Routes.deleteAccount);
        break;

      case "ReportIssue":
        push(Routes.more + Routes.reportIssue);
        break;

      case "History":
        push(Routes.more + Routes.history);
        break;

      case "ChangeLanguage": {
        const nextLanguage =
          language === "en" ? "hi" : language === "hi" ? "mr" : "en";

        setLanguage(nextLanguage);
        i18n.changeLanguage(nextLanguage);
        localStorage.setItem("i18nextLng", nextLanguage);
        break;
      }
    }
  };

  return (
    <div className="moreRoot">
      <div className="morePage">
        <div className="moreGrid">
          {MoreCardDetails.map((item) => (
            <Card
              key={item.key}
              hoverable
              className="moreCard"
              onClick={() => cardOnClick(item.key)}
              role="button"
              tabIndex={0}
              onKeyDown={(event) => {
                if (event.key === "Enter" || event.key === " ") {
                  event.preventDefault();
                  cardOnClick(item.key);
                }
              }}
            >
              <div className="moreCardContent">
                <div className="moreCardLeft">
                  <div className="iconContainer">{item.logoUrl}</div>

                  <div className="moreText">
                    <Typography.Text className="moreTitle">
                      {item.title}
                    </Typography.Text>

                    <Typography.Text className="moreDescription">
                      {item.description}
                    </Typography.Text>
                  </div>
                </div>

                <Arrow className="moreArrow" />
              </div>
            </Card>
          ))}
        </div>

        {/* <div className="moreFooter">
          <img src={icon} className="inkLogo" alt="INK" />
          <Typography.Text className="versionText">
            Version 1.0.1
          </Typography.Text>
        </div> */}
      </div>
    </div>
  );
};

export default MoreScreen;